import React, { useEffect, useState } from 'react';
import { Link } from "react-router-dom";

const employees = [
  { id: 1, name: "John Doe" },
  { id: 2, name: "Jane Smith" },
  { id: 3, name: "Michael Johnson" }
];

function fetchAttendance(employeeId, year, month) {

  return new Promise(resolve => {
    setTimeout(() => {
      let attendance = {};
      const daysInMonth = new Date(year, month + 1, 0).getDate();
      for (let day = 1; day <= daysInMonth; day++) {
        const dateStr = `${year}-${(month + 1).toString().padStart(2, '0')}-${day
          .toString().padStart(2, '0')}`;
        attendance[dateStr] = Math.random() < 0.5;  // Random data for simulation
      }
      resolve(attendance);
    }, 500);
  });
}

function saveAttendance(employeeId, year, month, attendance) {
  // Simulated API call for saving attendance data
  return new Promise(resolve => {
    setTimeout(() => resolve({ success: true }), 500);
  });
}

function EmployeeMonthlyUpdate() {

  const [employeeId, setEmployeeId] = useState(employees[0].id);
  const [currentDate, setCurrentDate] = useState(new Date());
  const [attendanceData, setAttendanceData] = useState({});

  useEffect(() => {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    fetchAttendance(employeeId, year, month).then(data => {
      setAttendanceData(data);
    });
  }, [employeeId, currentDate]);

  function updateMonth(offset) {
    setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + offset, 1));
  }

  function toggleAttendance(dateStr) {
    setAttendanceData(prev => ({
      ...prev,
      [dateStr]: !prev[dateStr]
    }));
  }

  function handleSave() {
    const year = currentDate.getFullYear();
    const month = currentDate.getMonth();
    // Convert attendanceData mapping to array format if necessary
    const attendanceArray = Object.entries(attendanceData).map(([date, present]) => ({ date, present }));
    saveAttendance(employeeId, year, month, attendanceArray)
      .then(response => {
        if (response.success) alert('Attendance saved!');
      });
  }

  // Calculate calendar weeks starting from Saturday
  const month = currentDate.getMonth();
  const year = currentDate.getFullYear();
  const monthNames = ["January", "February", "March", "April", "May", "June", "July",
    "August", "September", "October", "November", "December"];
  const currentMonthStr = `${monthNames[month]} ${year}`;

  let startDate = new Date(year, month, 1);
  while (startDate.getDay() !== 6) { // find the first Saturday on or before the 1st
    startDate.setDate(startDate.getDate() - 1);
  }

  let weeks = [];
  let current = new Date(startDate);
  for (let w = 0; w < 4; w++) {
    let week = [];
    for (let d = 0; d < 7; d++) {
      week.push(new Date(current));
      current.setDate(current.getDate() + 1);
    }
    weeks.push(week);
  }

  const dayNames = ["Sat", "Sun", "Mon", "Tue", "Wed", "Thu", "Fri"];

  return (
    <main id="main" className="main">
      <div className="pagetitle">
        <h1>Attendance Update</h1>
        <nav>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/dashboard">Home</Link>
            </li>
            <li className="breadcrumb-item active">Attendance Update</li>
          </ol>
        </nav>
      </div>

      <section className="section">
        <div className="row">
          <div className="col-lg-12">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Employee Attendance Update</h5>
                <div>

                  <div className="container">

                    <div className="row mb-4">
                      <div className="col-md-6">
                        <label className="form-label">Select Employee:</label>
                        <select
                          className="form-select"
                          value={employeeId}
                          onChange={e => setEmployeeId(Number(e.target.value))}
                        >
                          {employees.map(emp => (
                            <option key={emp.id} value={emp.id}>
                              {emp.name}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="col-md-6 d-flex align-items-end">
                        <div className="month-nav d-flex align-items-center">
                          <button className="btn btn-outline-primary btn-sm" onClick={() => updateMonth(-1)}>
                            &laquo; Prev
                          </button>
                          <h5 className="mx-3 mb-0">{currentMonthStr}</h5>
                          <button className="btn btn-outline-primary btn-sm" onClick={() => updateMonth(1)}>
                            Next &raquo;
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      {weeks.map((week, weekIndex) => (
                        <div className="col-md-3" key={weekIndex}>
                          <div className="card mb-3">
                            <div className="card-body">
                              {week.map((dateObj, dayIndex) => {
                                const inCurrentMonth = dateObj.getMonth() === month;
                                const dateStr = `${dateObj.getFullYear()}-${(dateObj.getMonth() + 1)
                                  .toString().padStart(2, '0')}-${dateObj.getDate().toString().padStart(2, '0')}`;
                                return (
                                  <div className="form-check mb-2" key={dayIndex}>
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id={`day-${dateStr}`}
                                      checked={inCurrentMonth ? !!attendanceData[dateStr] : false}
                                      disabled={!inCurrentMonth}
                                      onChange={() => toggleAttendance(dateStr)}
                                    />
                                    <label className="form-check-label" htmlFor={`day-${dateStr}`}>
                                      {dayNames[dayIndex]} {dateObj.getDate()}
                                    </label>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    <button className="btn btn-success" onClick={handleSave}>Save</button>
                  </div>



                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );

}

export default EmployeeMonthlyUpdate;
